module.exports = __webpack_public_path__ + "8bffd0e13389da51b68da1278d5c9abc.svg";